import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  //inject services
  constructor(private auth: AuthenticationService, private router: Router) { }

  //checks login status to protect routes
  canActivate() {
    //see if the user is logged in
    if (this.auth.isLoggedIn() == true) {
      //logged in 
      return true;
    } else {
      //not logged in
      this.router.navigate(['/home']);
      return false;
    }
  }
}

